import axios from 'axios'

if (process.env.NODE_ENV !== 'development') {
    //axios.defaults.baseURL = 'http://218.200.15.150:81/xs/'; 
    axios.defaults.baseURL = 'https://www.sxxskw.com/MyNosql/';  
}
